<template>
	<PlaceholderPanel class="new-goal-activity-panel">
		<template #title>{{ translate( "title" ) }}</template>
		<template #body>
			<p>{{ translate( "description" ) }}</p>
		</template>
	</PlaceholderPanel>
</template>

<script>
import PlaceholderPanel from "../Common/PlaceholderPanel";
export default {
	name: "NewGoalActivityPanel",
	components: {
		PlaceholderPanel,
	},
	methods: {
		translate( key, args ) {
			return this.$t( `common-gokr.components.NewGoalActivityPanel.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped></style>
